import React from "react";
import VideoRow from "./VideoRow";
import "./additionalStyles.css";

const VideoPresentation = ({ showVideo, expanded, setExpanded, videos }) => {
  let videoCount = expanded ? videos.length : 2;
  return (
    <div className={`${showVideo ? "videoContainer" : "hideDiv"}`}>
      <p className="headerText">Progress Videos</p>
      <div className="customHl" style={{ marginBottom: "20px" }} />
      {videos.slice(0, videoCount).map((vid, index) => {
        return (
          <VideoRow
            key={`video-${index}`}
            backgroundColor={index % 2 === 0 ? "#DEDEDE" : "white"}
            videoLink={vid.videoLink}
            title={vid.title}
            dateStamp={vid.dateStamp}
            description={vid.description}
          />
        );
      })}
      <button
        className="readMoreButton"
        onClick={() => setExpanded(expanded ? false : "Video")}
      >
        {expanded ? "Close" : "See All"}
      </button>
    </div>
  );
};

export default VideoPresentation;

/*

*/
